module.exports = __webpack_public_path__ + "static/media/edit-pencil-dark.8d5c20b0.svg";